var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 11.5C23.001 5.14873 17.8523 0 11.501 0C5.1497 0 0.000976562 5.14873 0.000976562 11.5C0.000976562 17.8513 5.1497 23 11.501 23C17.8523 23 23.001 17.8513 23.001 11.5Z",
    fill: "#FF0002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75293 9.78286L8.46793 10.3179L7.79092 12.5249L11.4909 9.75586L7.75293 9.78286Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.713 10.9149L11.954 12.8339L12.861 13.4879H10.073L19.25 6.81494L11.458 7.68794L3.75098 6.81494L6.95098 9.19394H13.215L4.31498 15.8709L11.341 15.0289L18.247 15.8709L15.147 13.5709L14.713 10.9149Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStz);
export default __webpack_public_path__ + "static/media/stz.0abac203ec2a527c14f6f4789e00a520.svg";
export { ForwardRef as ReactComponent };